import { combineReducers } from "redux";
import { IIGSEState } from "../../../shared/igse-redux/igse-state";
import { SortableListBuilderColumns } from "../enum/list-builder-table-columns";
import { IListBuilderTableResponseDto } from "../interface/dto/list-builder-table-list.dto";
import { IUserDto } from "../interface/dto/list-builder-users.dto";
import { listBuilderUsersReducer } from ".";
import {
    ListBuilderTableActionType,
    IListBuilderTableActions,
} from "./list-builder-table-page.action";

export interface IListBuilderTableState {
    listBuilders?: IListBuilderTableResponseDto;
    isLoading: boolean;
    error?: string;
    pagination: {
        currentPage: number;
        itemsPerPage: number;
    };
    sorting: {
        column: SortableListBuilderColumns;
        order: "asc" | "desc";
    };
    currentUser?: {
        email: string;
    };
    searchQuery: string;
    isActionInProgress: boolean;
    canCreateMoreListBuilders: boolean;
}

export const initialState: IListBuilderTableState = {
    isLoading: false,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
    },
    sorting: {
        column: SortableListBuilderColumns.LAST_BUILD,
        order: "desc",
    },
    searchQuery: "",
    isActionInProgress: false,
    canCreateMoreListBuilders: false,
};

export const listBuilderTableReducer = (
    state = initialState,
    action: IListBuilderTableActions,
): IListBuilderTableState => {
    switch (action.type) {
        case ListBuilderTableActionType.LIST_BUILDER_TABLE_INIT:
            return {
                ...state,
                searchQuery: "",
                pagination: initialState.pagination,
                sorting: initialState.sorting,
            };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_LOAD:
            return { ...state, isLoading: true, isActionInProgress: false };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isActionInProgress: false,
                listBuilders: action.payload,
                error: undefined,
            };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_ERROR:
            return { ...state, isLoading: false, isActionInProgress: false };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SORTING:
            return { ...state, sorting: action.payload };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...action.payload,
                    currentPage:
                        action.payload.itemsPerPage !==
                        state.pagination.itemsPerPage
                            ? 1
                            : action.payload.currentPage,
                },
            };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_SEARCH_QUERY:
            return {
                ...state,
                searchQuery: action.payload,
                pagination: { ...state.pagination, currentPage: 1 },
            };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_DUPLICATE:
        case ListBuilderTableActionType.LIST_BUILDER_TABLE_DELETE:
        case ListBuilderTableActionType.LIST_BUILDER_TABLE_BUILD:
        case ListBuilderTableActionType.LIST_BUILDER_TABLE_DOWNLOAD:
            return { ...state, isActionInProgress: true };

        case ListBuilderTableActionType.LIST_BUILDER_TABLE_SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload,
                pagination: { ...state.pagination, currentPage: 1 },
            };
        case ListBuilderTableActionType.LIST_BUILDER_TABLE_CHECK_CREATE_PERMISSION_SUCCESS:
            return { ...state, canCreateMoreListBuilders: action.payload };
        default:
            return state;
    }
};

export const listBuilderTablePageReducer = combineReducers({
    listBuilderTable: listBuilderTableReducer,
    listBuilderUsers: listBuilderUsersReducer,
});

export interface IListBuilderTablePageState {
    listBuilderTable: IListBuilderTableState;
    listBuilderUsers: IIGSEState<Array<IUserDto>>;
}
